import { TemplateParamsPlugin } from "/srv/projects/www.kliniken-delitzsch-eilenburg.de/public/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.154.0_esbuild@0.28.2_lightningcss@1.33.0_rolldow_6c3fcc96b1ebdd6f80fca9cceb831cd8/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  plugins: [TemplateParamsPlugin],
}